<template>
  <NfFormItem icon="unit" label="参评地市" @click="handleClick">
    <div class="select-wrapper" slot="right">
      <span class="text" :class="labelValue === placeholder ? 'placeholder' : ''">{{ labelValue }}</span>
      <i class="icon icon-arrow-right"></i>
    </div>
  </NfFormItem>
</template>

<script>
import NfFormItem from "./NfFormItem"

export default {
  name: "uiFormItemUnit",
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    placeholder: {
      type: String,
      default: "请选择"
    }
  },
  data() {
    return {}
  },
  methods: {
    handleClick() {
      this.$emit("showChooseUnit")
      // this.$router.push({ path: "/chooseUnit" })
    }
  },
  components: {
    NfFormItem
  },
  computed: {
    labelValue: {
      get() {
        return this.value.companyName || this.placeholder
      },
      set(value) {
        this.$emit("input", value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select-wrapper {
  display: flex;
  align-items: center;
  .text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 0.2rem;
    &.placeholder {
      color: #999999;
    }
  }
  .icon-arrow-right {
    width: 0.3rem;
    height: 0.3rem;
    background: url("../../assets/images/icon_arrow.png") no-repeat center;
    background-size: 100%;
    flex: none;
  }
}
</style>
